import { NotificationContext } from "components/common/Notifications/NotificationProvider";
import ScenarioConfigContext from "Context/ScenarioConfigContext";
import UserContext from "Context/UserProvider";
import { useContext, useEffect, useRef, useState } from "react";
import toast from 'react-hot-toast';
import { useLocation } from "react-router-dom";
import { v4 } from "uuid";
import IceVehicleTable from "./components/IceVehicleTable";
import UploadProgressTable from "./components/UploadProgressTable";
import { 
    Box, 
    CircularProgress, 
    Tabs,
    Tab,
    Typography,
    Paper
} from '@mui/material';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { useApiService } from "../../../../services/ApiService/ApiService";

function IceVehiclePage(props: any) {
    const [scenarioConfigInfo, setScenarioConfigInfo] = useContext(ScenarioConfigContext) as any;
    const location = useLocation() as any;
    const fleetScenarioUuid = scenarioConfigInfo.draftScenario?.uuid;
    const [allVehicles, setAllVehicles] = useState([] as any);
    const [notificationStatus, setNotificationStatus] = useState([]) as any;
    const [incompleteFiles, setIncompleteFiles] = useState([]) as any;
    const [vehicleStatus, setVehicleStatus] = useState([]) as any;
    const notificationContext = useContext(NotificationContext);
    const [statusPolling, setStatusPolling] = useState(false);
    const [initialising, setInitialising] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const { userInfo, setUserInfo } = useContext(UserContext);
    const { fetchWithAuth } = useApiService();
    const [activeMenu, setActiveMenu] = useState(location.state?.showCategory ? (location.state?.showCategory[0] ? "Current Fleet" : "Progress") : "Current Fleet");
    const [loading, setLoading] = useState(true);
    const [showSecondaryCategory, setShowSecondaryCategory] = useState(location.state?.showCategory ? location.state.showCategory : [true, false]);
    const [isError, setIsError] = useState(false);

    function checking_null_undefined(array: any) {
        if (array === null || array === undefined) {
            return [];
        }
        return array;
    }

    //******************** Important function for getting the access token and authorization api *************************//

    function updatedStatusNotification(a1: [any], a2: [any]) {
        a1 = checking_null_undefined(a1);
        a2 = checking_null_undefined(a2);
        let result = a1.filter(({ id: id1, status: status1 }) => !a2.some(({ id: id2, status: status2 }) => id2 === id1 && status1 === status2));

        if (JSON.stringify(result) !== JSON.stringify(notificationStatus)) {
            if (result.length > 0) {
                if (result.length < notificationStatus.length) {
                    notificationStatus
                        .filter((e: any) => result.includes(e))
                        .map((e: any) =>
                            notificationContext.dispatch({
                                type: "ADD_NOTIFICATION",
                                payload: {
                                    id: v4(),
                                    type: "SUCCESS",
                                    message: `Vehicle ${e.registrationNumber} is completed`,
                                },
                            })
                        );
                } else {
                    for (let i = 0; i < result.length; i++) {
                        if (result[i].statusDescription === "Not an N1 Category Vehicle" || result[i].statusDescription === "DVLA Vehicle Details Not Found") {
                            notificationContext.dispatch({
                                type: "ADD_NOTIFICATION",
                                payload: {
                                    id: v4(),
                                    type: "ERROR",
                                    message: `Vehicle ${result[i].registrationNumber} is deleted`,
                                },
                            });
                        } else {
                            // setNotifications((prev: any) => [...prev, { message: `Vehicle ${result[i].registrationNumber} is currently ${result[i].statusDescription}` }])
                            notificationContext.dispatch({
                                type: "ADD_NOTIFICATION",
                                payload: {
                                    id: v4(),
                                    type: "SUCCESS",
                                    message: `Vehicle ${result[i].registrationNumber} is currently ${result[i].statusDescription}`,
                                },
                            });
                        }
                    }
                }
            }
            setNotificationStatus((prev: any) => result);
        }
        // return result;
    }

    async function fetchVehicleList() {
        setLoading(true);
        try {
            const response = await fetchWithAuth(`/DragDrop/fleet/icevehicle/list?t='${Math.random()}'`, {
                method: 'POST',
                body: JSON.stringify({
                    uuid: userInfo.uuid,
                    fleetUuid: userInfo.fleetUuid
                })
            });

            const res_json = await response.json();
            console.log(JSON.stringify(res_json));

            if (!response.ok) {
                switch (res_json.code) {
                    case "FLEET_SCENARIO_INITIALISING":
                    case "FLEET_SCENARIO_NOT_DRAFT":
                        setInitialising(true);
                        break;
                    default:
                        console.log("fs " + fleetScenarioUuid);
                        setErrorMessage(`An error (${res_json.code}) occurred whilst during data retrieval.`);
                        break;
                }
                return;
            }

            let iceVehicleList = checking_null_undefined(res_json.iceVehicleList);
            let iceVehicles = checking_null_undefined(
                iceVehicleList.map((e: any) => ({
                    ...e,
                    id: e.uuid,
                    selected: e.selected,
                }))
            );
            // let iceVehicles = res_json.iceVehicles
            iceVehicles = checking_null_undefined(iceVehicles);
            setAllVehicles(iceVehicles);
        } catch (error) {
            console.error('Error fetching vehicle list:', error);
            setErrorMessage('Failed to fetch vehicle list');
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (errorMessage) {
            toast.error(errorMessage, {
                position: 'bottom-center',
                duration: 5000,
            });
        }
        setErrorMessage(null);
    }, [errorMessage]);


    async function checkStatus() {
        try {
            const response = await fetchWithAuth('/DragDrop/status', {
                method: 'POST',
                body: JSON.stringify({
                    uuid: userInfo.uuid,
                    fleetUuid: userInfo.fleetUuid
                })
            });


            const json_res = await response.json();

            console.log(JSON.stringify(json_res));

            let files = checking_null_undefined(json_res.files).map((e: any) => ({ ...e, id: e.uuid }));
            let unfinishedFile = files.filter((e: any) => e.status !== "DONE");
            let currentRunningFile = files.filter((e: any) => {
                return e.status !== "DONE" && e.status !== "EXTRACT_CSV_FILES_FAILED";
            });
            // let failedFile = json_res.files.filter((e:any)=> e === "FAILED")

            //For notification
            updatedStatusNotification(vehicleStatus, unfinishedFile);
            setVehicleStatus(unfinishedFile);

            //Set current status

            setIncompleteFiles((prev: any) => {
                if (currentRunningFile.length === 0) {
                    setStatusPolling(false);
                    fetchVehicleList();
                    return unfinishedFile;
                }
                if (prev.length !== unfinishedFile.length) {
                    fetchVehicleList();
                    return unfinishedFile;
                }
                if (JSON.stringify(prev) !== JSON.stringify(unfinishedFile)) {
                    return unfinishedFile;
                }
                return prev;
            });
        } catch (error) {
            console.error('Error checking status:', error);
            toast.error('Failed to check status');
        }
    }

    async function isPollingRequired() {
        try {
            const response = await fetchWithAuth('/DragDrop/status', {
                method: 'POST',
                body: JSON.stringify({
                    uuid: userInfo.uuid,
                    fleetUuid: userInfo.fleetUuid
                })
            });

            const json_res = await response.json();

            console.log(JSON.stringify(json_res));
            let files = checking_null_undefined(json_res.files).map((e: any) => ({ ...e, id: e.uuid }));
            let unfinishedFile = files.filter((e: any) => (e.status !== "DONE" && e.status !== "DONE_WITH_ERRORS"));
            let failedFiles = files.filter((e: any) => e.status === "FAILED");

            if (unfinishedFile.length === 0) {
                setIncompleteFiles(files);
                setStatusPolling(false);
            } else {
                setVehicleStatus(unfinishedFile);
                setIncompleteFiles(files);
                setStatusPolling(true);
            }
        } catch (error) {
            console.error('Error checking polling status:', error);
            toast.error('Failed to check polling status');
        }
    }

    const componentMounted = useRef(true); // (3) component is mounted
    // ...
    useEffect(() => { }, [incompleteFiles]);
    useEffect(() => {
        // When request is finished:
        // if (componentMounted.current) { // (5) is component still mounted?
        isPollingRequired();
         fetchVehicleList();

        setLoading(false); // (2) write some value to state
        // }

        // return () => { // This code runs when component is unmounted
        //     componentMounted.current = false; // (4) set it to false when we leave the page
        // }
    }, []);

    //UseInterval(checkStatus, 1000, statusPolling);
    useEffect(() => { }, [statusPolling]);

    // const yourFleetHeader = <h1><b>Telematics</b></h1>
    return (
        <>
            {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                    <CircularProgress />
                </Box>
            ) : (
                <Box
                    component="section"
                    sx={{ p: 3 }}
                >
                        <Tabs 
                            value={activeMenu === "Current Fleet" ? 0 : 1}
                            onChange={(e, newValue) => {
                                setActiveMenu(newValue === 0 ? "Current Fleet" : "Progress");
                                setShowSecondaryCategory([newValue === 0, newValue === 1]);
                            }}
                            sx={{ borderBottom: 1, borderColor: 'divider' }}
                        >
                            <Tab 
                                icon={<DirectionsCarIcon />} 
                                iconPosition="start"
                                label="Current Fleet" 
                                disabled={initialising}
                            />
                            <Tab 
                                icon={<UploadFileIcon />} 
                                iconPosition="start"
                                label="Progress" 
                            />
                        </Tabs>

                    {activeMenu === "Current Fleet" ? (
                        <Box>
                            {initialising ? (
                                <Box sx={{ p: 3, textAlign: 'center' }}>
                                    <CircularProgress size={40} sx={{ mb: 2 }} />
                                    <Typography>
                                        Initialising fleet scenario, please wait...
                                    </Typography>
                                </Box>
                            ) : (
                                <IceVehicleTable
                                    allVehicles={[allVehicles, setAllVehicles]}
                                    userInfo={userInfo}
                                    loading={loading}
                                />
                            )}
                        </Box>
                    ) : (
                        <Box>
                            <UploadProgressTable
                                incompleteFiles={incompleteFiles}
                                userInfo={userInfo}
                                statusPolling={[statusPolling, setStatusPolling]}
                            />
                        </Box>
                    )}
                </Box>
            )}
        </>
    );
}

export default IceVehiclePage;